export const websiteUrl = process.env.REACT_APP_WEBSITE_URL
  ? process.env.REACT_APP_WEBSITE_URL
  : "https://dev-portal.mytripify.com";
export const webCliendId = process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID
  ? process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID
  : "604deg3s5oqf6692338ovkcai2";
